import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=4b252e3e&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=4b252e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b252e3e",
  null
  
)

export default component.exports